// hooks/useDropdownHover.js
import { useState, useRef } from "react";

export function useDropdownHover(delay = 200) {
const [isOpen, setIsOpen] = useState(false);
const hideTimeout = useRef(null);

const handleMouseEnter = () => {
    clearTimeout(hideTimeout.current);
    setIsOpen(true);
};

const handleMouseLeave = () => {
    hideTimeout.current = setTimeout(() => setIsOpen(false), delay);
};

return { isOpen, handleMouseEnter, handleMouseLeave };
}
